export const Datas = [
    {
        
        "id": 1,
        "userid" : "sumit-kumar",
        "name": 'Sumit Kumar',
        "initials": "sk",
        "image": require('../Images/59.jpg'),
        "link" : 'https://sumit2011.github.io',
        "instagram" : "https://www.instagram.com/_su__mit___",
        "twitter" : 'https://twitter.com/_su__mit___',
        "facebook" : "https://www.facebook.com/sumit2011",
        "linkedin" : "https://ece2021nitsgr.netlify.app/user/sumit-kumar",
        "enroll": "2021BECE059"
        
        
    },
    {
        "id": 2,
        "name": 'Sunny kr. kushwaha',
        "userid" : "sunny-kushwaha",
        "initials": "sk",
        "image": require('../Images/54.jpeg'),
        "link" : "https://sunnykushwaha18.github.io/sunnykushwaha.github.io/",
        "instagram" : "https://www.instagram.com/____sunny_kushwaha_18/",
        "twitter" : 'https://x.com/SunnyKumarKus13',
        "facebook" : "https://www.facebook.com/sunnykumarkushwaha01/",
        "linkedin" : "http://linkedin.com/in/sunnykumar18",
        "enroll": "2021BECE054"
    },
    {
        "id": 3,
        "userid" : "prateek-kumar",
        "name": "Prateek Kumar",
        "initials": "Pk",
        "image": require('../Images/30.jpeg'),
        "link" : "https://prateek1833.github.io/",
        "instagram" : "",
        "twitter" : "https://x.com/024_Prateek?t=2vq53dEx9ERsGg2_hk-UTg&s=09",
        "facebook" : "",
        "linkedin" : "https://www.linkedin.com/in/prateek-kumar-342a98312/",
        "enroll": "2021BECE030"
    },
    {
        "id": 4,
        "userid" : "md-saif",
        "name": "Md Saif",
        "initials": "Ms",
        "image": require('../Images/46.jpeg'),
        "link" : "https://mdsaifin.github.io/",
        "instagram" : "https://www.instagram.com/mdsaif.in/",
        "twitter" : "",
        "facebook" : "https://www.facebook.com/profile.php?id=100030745783834/",
        "linkedin" : "https://www.linkedin.com/in/mdsaif-in/",
        "enroll": "2021BECE046"
    },
    {
        "id": 5,
        "userid" : "nitendra-kumar",
        "name": "Nitendra Kumar",
        "initials": "Nk",
        "image": require('../Images/79.jpg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/nitendra-kumar",
        "instagram" : "",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : " ",
        "enroll": "2021BECE079"
    },
    {
        "id": 6,
        "userid" : "balram-nishad",
        "name": "Balram Nishad",
        "initials": "sk",
        "image": require('../Images/50.jpg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/balram-nishad",
        "instagram" : "https://www.instagram.com/mdsaif.in/nishad_balram0198",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "https://www.linkedin.com/in/balram-nishad/",
        "enroll": "2021BECE050"
    },
    {
        "id": 7,
        "userid" : "abhijeet-kumar",
        "name": "Abhijeet Kumar",
        "initials": "sk",
        "image": require('../Images/45.jpg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/abhijeet-kumar",
        "instagram" : "https://www.instagram.com/oyee_.abhi",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : " ",
        "enroll": "2021BECE045"
    },
    {
        "id": 8,
        "userid" : "shams-reza",
        "name": "Shams Reza ",
        "initials": "Ms",
        "image": require('../Images/37.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/shams-reza",
        "instagram" : "https://www.instagram.com/Arezshams084",
        "twitter" : "https://x.com/Shams@Reza",
        "facebook" : "https://www.facebook.com/shams.sahi.5",
        "linkedin" : "https://in.linkedin.com/in/shams-reza-96a834246",
        "enroll": "2021BECE037"
    },
    {
        "id": 9,
        "userid" : "ajaruddin-ansari",
        "name": "Ajaruddin Ansari",
        "initials": "AA",
        "image": require('../Images/47.jpg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/ajaruddin-ansari",
        "instagram" : "https://www.instagram.com/ajaruddin7820",
        "twitter" : "",
        "facebook" : "https://www.facebook.com/share/h1xtz7yN4Km5L3X5/",
        "linkedin" : "https://www.linkedin.com/in/ajaruddin-ansari-4b3793227/",
        "enroll": "2021BECE047"
    },
    {
        "id": 10,
        "userid" : "bhuvanesh",
        "name": "Bhuvanesh",
        "initials": "sk",
        "image": require('../Images/49.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/bhuvanesh",
        "instagram" : "https://www.instagram.com/bhuvanesh__20",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "https://in.linkedin.com/in/bhuvanesh-potabattula-301338294",
        "enroll": "2021BECE049"
    },
    {
        "id": 11,
        "userid" : "salman-zubair",
        "name": "Salman Zubair",
        "initials": "sk",
        "image": require('../Images/44.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/salman-zubair",
        "instagram" : "https://www.instagram.com/07_bhurae_07",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "https://in.linkedin.com/in/salman-zubair-a38735271",
        "enroll": "2021BECE044"
    },
    {
        "id": 12,
        "userid" : "satyam-kumar",
        "name": "Satyam Kumar",
        "initials": "sk",
        "image": require('../Images/53.jpg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/satyam-kumar",
        "instagram" : "https://www.instagram.com/_s4tyam_",
        "twitter" : "https://www.twitter.com/Satyamkumar3110",
        "facebook" : "https://www.facebook.com/s4tyam",
        "linkedin" : "https://www.linkedin.com/in/satyam-kumar-04a0a3252",
        "enroll": "2021BECE053"
    },
    {
        "id": 13,
        "userid" : "mahi-soni",
        "name": "Mahi Soni",
        "initials": "MS",
        "image": require('../Images/62.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/mahi-soni",
        "instagram" : "",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : " ",
        "enroll": "2021BECE062"
    },
    {
        "id": 14,
        "userid" : "arjun-pandit",
        "name": "Arjun Pandit",
        "initials": "sk",
        "image": require('../Images/68.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/arjun-pandit",
        "instagram" : "",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : " ",
        "enroll": "2021BECE068"
    },
    {
        "id": 15,
        "userid" : "md-ibrahim",
        "name": "Md Ibrahim",
        "initials": "sk",
        "image": require('../Images/48.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/md-ibrahim",
        "instagram" : "https://www.instagram.com/",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : " ",
        "enroll": "2021BECE048"
    },
    {
        "id": 16,
        "userid" : "sanskruti-kakad",
        "name": "Sanskruti kakad",
        "initials": "sk",
        "image": require('../Images/63.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/sanskruti-kakad",
        "instagram" : "https://www.instagram.com/",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : " ",
        "enroll": "2021BECE063"
    },
    {
        "id": 17,
        "userid" : "shankar-munda",
        "name": "Shankar Munda",
        "initials": "sk",
        "image": require('../Images/95.png'),
        "link" : "https://ece2021nitsgr.netlify.app/user/shankar-munda",
        "instagram" : "https://www.instagram.com/_shankar_munda",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE097"
    },
    {
        "id": 18,
        "userid" : "rokesh-mittal",
        "name": "Rokesh Mittal",
        "initials": "sk",
        "image": require('../Images/32.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/rokesh-mittal",
        "instagram" : "https://www.instagram.com/rokeshmittal",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE032"
    },
    {
        "id": 19,
        "userid" : "wakeel-ahmad",
        "name": "Wakeel Ahmad Kumar",
        "initials": "sk",
        "image": require('../Images/65.png'),
        "link" : "https://ece2021nitsgr.netlify.app/user/wakeel-ahmad",
        "instagram" : "https://www.instagram.com/_wakeelkumar_",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE065"
    },
    {
        "id": 20,
        "userid" : "darshana-dayare",
        "name": "Darshana Dayare",
        "initials": "DD",
        "image": require('../Images/64.jpg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/darshana-dayare",
        "instagram" : "https://www.instagram.com/darshana_dayare",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "https://in.linkedin.com/in/darshana-dayare-568a4a227",
        "enroll": "2021BECE064"
    },
    {
        "id": 21,
        "userid" : "singidi-dileep",
        "name": "Singidi Dileep",
        "initials": "sk",
        "image": require('../Images/57.png'),
        "link" : "https://ece2021nitsgr.netlify.app/user/singidi-dileep",
        "instagram" : "",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE057"
    },
    {
        "id": 22,
        "userid" : "shivam-kumar",
        "name": "Shivam Kumar",
        "initials": "sk",
        "image": require('../Images/83.png'),
        "link" : "https://ece2021nitsgr.netlify.app/user/shivam-kumar",
        "instagram" : "https://www.instagram.com/shi_vam65_",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE083"
    },
    {
        "id": 23,
        "userid" : "pankaj-kumar",
        "name": "Pankaj Kumar",
        "initials": "pk",
        "image": require('../Images/52.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/pankaj-kumar",
        "instagram" : "https://www.instagram.com/Pankajpkkr",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE052"
    },
    {
        "id": 24,
        "userid" : "sakshi",
        "name": "Sakshi",
        "initials": "sk",
        "image": require('../Images/38.jpeg'),
        "link" : "https://ece2021nitsgr.netlify.app/user/sakshi",
        "instagram" : "https://www.instagram.com/sakshiagrawal8719",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE038"
    },
    {
        "id": 25,
        "userid" : "gugulothu-rahul-nayak",
        "name": "Gugulothu Rahul Nayak",
        "initials": "sk",
        "image": require('../Images/1.png'),
        "link" : "https://ece2021nitsgr.netlify.app/user/gugulothu-rahul-nayak",
        "instagram" : "https://www.instagram.com/rahul_guguloth2",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": "2021BECE095"
    },
    {
        "id": 26,
        "userid" : "",
        "name": "Waiting for you",
        "initials": "sk",
        "image": require('../Images/1.png'),
        "link" : "https://ece2021nitsgr.netlify.app",
        "instagram" : "https://www.instagram.com/",
        "twitter" : "",
        "facebook" : "",
        "linkedin" : "",
        "enroll": ""
    },
    
];
